import { createContext } from 'react';

const MobileViewContext = createContext({
	mobileView: false,
	setMobileView: () => {},
});

export default MobileViewContext;
